<template>
  <div>
    <v-row
      class="align-center justify-start mx-0"
      style="background-color:#f5f5f5; position:fixed; z-index: 10; min-width: -webkit-fill-available;"
    >
      <v-row>
        <v-col cols="5">
          <span
            class="text-start"
            style="color:#777; font-size:14px;"
          >AÑADIR STAND</span>
        </v-col>
        <v-spacer />

        <v-col cols="1" style="min-width: fit-content;" class="pa-1">
          <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-35px;">
            <v-icon style="cursor: pointer; font-size:16px" @click="closeRightMenu">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>

    <v-container>
      <v-row class="row align-center justify-center pl-4 pr-4 pb-12 row-margin-top-45">
        <v-col cols="12">

        <v-data-table
                v-model="selected"
                show-select
                :items="arrStands"
                :headers="headers"
                item-key="idResource"
                class="elevation-0"
                style="color: #777; cursor:pointer; height: "
                sortBy="idResource"
                update: sort-desc
              >
                <template v-slot:item.icon>
                  <v-icon :color="(item.operative === 1) ? 'admiraGreen' : 'gray'" >mdi-store</v-icon>
                </template>

              <!-- <template v-slot:item.actions=" {item} ">
                 <v-btn v-on="on" icon small @click="infoStand(item)">
                    <v-icon dark>mdi-information-variant</v-icon>
                  </v-btn>
                </template> -->

              </v-data-table>
        </v-col>
      </v-row>

      <div style="position: fixed; bottom: 0;background-color: white; width: 100%;">
        <v-divider style="mx-0"></v-divider>

        <v-row class="mb-2 pr-6">

          <v-col cols="6">
            <v-btn
              @click="addNewResource(selected)"
              class="justify-center"
              rounded
              depressed
              color="admiraGreen"
              small
              dark
              width="120"
            >Añadir</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>

  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "RightMenuAddNewStand",
  data: () => ({
     typeQueueModel: "",
    selected: [],
    allSpacesModel: "",
    objValues: "",
    arrAllLocations: [],
    arrAllZones: [],
    nameZone: {}
  }),
  components: { HollowDotsSpinner },
  computed: {

    arrStands(){

      let asociatedSpaces = this.asociatedSpaces;
      let idResources = this.editedQueue.resources;
      let finalStands = [];

        asociatedSpaces.forEach(element => {
          if(idResources.includes(element.idResource)){

          }else{
            finalStands.push(element)
          }
        });

        return finalStands
    },
    ...mapState("queues", [ "spaceSelected","TicketsBySpace","editedQueue","allResouces","showRightMenu","objQueue", "allSpaces","asociatedSpaces","asociatedSpaces"]),
    headers() {
      return [
        { text: "", value: "icon", },
        { text: "Nombre", value: "name", align: "start", },
        { text: "", value: "actions", },
      ];
    },
  },
  methods: {
   
    ...mapMutations("queues", [
      "closeRightMenuMutation","openRightMenuMutation"
      
    ]),
    ...mapActions("queues", ["getAsociatedResourcesStore","rightMenuTrueNewDeviceTableStore4","editedQueueStore","rightMenuTrueNewDeviceTableStore3",
      "addQueueStore","getAllQueues"
    ]),


    addNewResource(data) {
      this.editedQueue.resources.push(data[0].idResource)
      this.editedQueueStore(this.editedQueue);
      this.closeRightMenuMutation();
      this.finalStands = [];
    },


   infoStand(data){

      this.closeRightMenuMutation();
      (this.RightMenuEditQueue = false),
      (this.RightMenuAddNewStand = false),
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();

   },
    closeRightMenu() { 
      this.finalStands = [];
      this.closeRightMenuMutation();
    }
  },
   created() {

  },
  mounted() {
   
  },
  destroyed() {
    this.finalStands = [];
  }
};
</script>

<style scoped>
>>> .v-navigation-drawer {
  width: 418px !important;
}

.newtext {
  font-family: "Roboto", sans-serif;
}
a {
  text-decoration: none;
}
.admira-icon {
  font-family: "Admira icons";
}
.boxImage {
  background-color: #f5f5f5;
  height: 255px;
  padding: 110px 0;
}
.row-margin-top-45 {
  margin-top: 45px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/RightMenuAddNewStand.vue